"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCloudFunctionsEndpointUrl = exports.createEntrepotApiWithIdentity = exports.defaultEntrepotApi = void 0;
// @ts-ignore: extjs has no types
const extjs_1 = __importDefault(require("../../../ic/extjs"));
exports.defaultEntrepotApi = extjs_1.default.connect('https://icp0.io/');
function createEntrepotApiWithIdentity(identity) {
    return extjs_1.default.connect('https://icp0.io/', identity);
}
exports.createEntrepotApiWithIdentity = createEntrepotApiWithIdentity;
function createCloudFunctionsEndpointUrl(paths) {
    return [
        'https://us-central1-entrepot-api.cloudfunctions.net',
        'api',
        ...paths,
    ].join('/');
}
exports.createCloudFunctionsEndpointUrl = createCloudFunctionsEndpointUrl;
